module.exports = __webpack_public_path__ + "static/img/officia.8bea0fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/workOrderReview/officia.png
// module id = n09s
// module chunks = 0